import { Duration } from 'dayjs/plugin/duration.js';
import { CapacityRange } from '../capacity-range.js';
import { TimeZone } from '../../../time/timezone.js';
import { isSameData, SerializedData } from '../../dto/dto.js';
import { TimeOfDay } from '../time-of-day.js';
import { CalendarDaySlot } from './calendar-day-slot.js';

export class GroupReservationCalendarSlot extends CalendarDaySlot {
  constructor(
    public readonly entryId: string,
    public readonly timeOfDay: TimeOfDay,
    public readonly duration: Duration,
    public readonly serviceId: string,
    public readonly capacity: CapacityRange,
    public occupancy: number,
  ) {
    super();
  }

  get groupId(): string {
    return this.entryId;
  }

  clone(): this {
    return new GroupReservationCalendarSlot(
        this.entryId,
        this.timeOfDay.clone(),
        TimeZone.cloneDuration(this.duration),
        this.serviceId,
        this.capacity.clone(),
        this.occupancy,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.entryId === this.entryId &&
        isSameData(other.timeOfDay, this.timeOfDay) &&
        isSameData(other.capacity, this.capacity) &&
        other.duration === this.duration &&
        other.serviceId === this.serviceId &&
        other.occupancy === this.occupancy;
  }

  toDiagnosticsObject(): SerializedData {
    return {
      'entryId': this.entryId,
      'timeOfDay': this.timeOfDay.asFormattedString,
      'duration': this.duration.asMinutes(),
      'serviceId': this.serviceId,
      'capacity': this.capacity.toDiagnosticsObject(),
      'occupancy': this.occupancy,
    };
  }
}
